import { PageTitle } from '@/components/seo/page-title';
import { BusinessListPage } from '@/screens/business/business-list-page';
import React from 'react';

export default function RecommendedScreen() {
  return (
    <>
      <PageTitle title="Recommended For You" />
      <BusinessListPage mode="recommended" title="Recommended For You" perPage={50} />
    </>
  );
}


